import { useFormik } from 'formik'
import { FC } from 'react'
import NumberFormat from 'react-number-format'
import PhoneInput from 'react-phone-number-input'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { trim } from '../../../../_metronic/helpers'
import { fetchStartWithForward } from '../../../../redux/actions/common'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import RangeSlider from 'react-bootstrap-range-slider'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { useHistory } from 'react-router-dom'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'
import { setLoanStep, setLoanSubStep } from '../redux/actions'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'
import { StaticCountrySelect } from '../../../../components/FixedSingaporePhoneComponent/StaticCountrySelect'

const errorMsg = {
  required: 'Required',
  amountRange: 'Amount range should be between 100,000 - 3,000,000',
  durationRange: 'Duration range should be between 3 - 36 months',
}

const industryOptions = [
  { label: 'Service Sector – F&B', value: 'service-sector-fb', rating: 'H', pricing: '21' },
  { label: 'Service Sector – non-F&B', value: 'service-sector-non-fb', rating: 'M', pricing: '15' },
  { label: 'Health & Human Services', value: 'health-human-services', rating: 'M', pricing: '15' },
  { label: 'Education', value: 'education', rating: 'L', pricing: '8' },
  { label: 'IT services', value: 'it-services', rating: 'L', pricing: '8' },
  { label: 'Media', value: 'media', rating: 'M', pricing: '15' },
  {
    label: 'Agriculture / Fishing / Food Production',
    value: 'agriculture-fishing-foodproduction',
    rating: 'H',
    pricing: '21',
  },
  { label: 'Wholesale Trader', value: 'wholesale-trader', rating: 'M', pricing: '15' },
  { label: 'Retail Trading', value: 'retail-trading', rating: 'M', pricing: '15' },
  {
    label: 'Manufacturing – heavy industries',
    value: 'manufacturing-heavy-industries',
    rating: 'M',
    pricing: '15',
  },
  {
    label: 'Manufacturing – consumer related',
    value: 'manufacturing-consumer-related',
    rating: 'M',
    pricing: '15',
  },
  {
    label: 'Manufacturing – computer & electronics',
    value: 'manufacturing-computer-electronics',
    rating: 'L',
    pricing: '8',
  },
  {
    label: 'Energy – generation and distribution',
    value: 'energy-generation-distribution',
    rating: 'H',
    pricing: '21',
  },
  { label: 'Transport & Logistics', value: 'transport-logistics', rating: 'M', pricing: '15' },
  { label: 'Renewable', value: 'renewable', rating: 'M', pricing: '15' },
  {
    label: 'Building and Construction - Private Sector',
    value: 'building-construction-private',
    rating: 'H',
    pricing: '21',
  },
  {
    label: 'Building and Construction - Public Sector',
    value: 'building-construction-public',
    rating: 'L',
    pricing: '8',
  },
  { label: 'Other', value: 'other', rating: 'M', pricing: '15' },
]

const loanPurpose = [
  { label: 'Business Expansion', value: 'business-expansion' },
  { label: 'Pay Invoices', value: 'pay-invoices' },
  { label: 'Equipment Purchase', value: 'equipment-purchase' },
  { label: 'Infrastructure Upgrades', value: 'infrastructure-upgrades' },
  { label: 'Working Capital', value: 'working-capital' },
  { label: 'Other', value: 'other' },
]

const maxAmount = 3000000
const minAmount = 100000
const maxDuration = 36
const minDuration = 3
const today = new Date()
// const fourDigitDate = new Date('1000');

// const dateObj = (d: any): any => {
//   return d
// }

// Add custom styles for the calendar icon
const calendarIconStyles = `
  .date-picker-wrapper {
    position: relative;
    width: 100%;
    cursor: pointer;
  }
  .calendar-icon-right {
    position: absolute !important;
    right: 10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    pointer-events: none;
    z-index: 2;
    cursor: pointer;
  }
  .react-datepicker__input-container input {
    width: 100%;
    padding-right: 30px;
  }
`

const Step1Sub3: FC<any> = ({
  createLoanEligibility,
  updateLoanElgibility,
  updateApplication,
}: any) => {
  const dispatch = useDispatch()
  const history = useHistory()
  /* 
  const [date, setDate] = useState(null)
  const [lastPickedDate, setLastPickedDate] = useState<any>(null);
  const [lastPickedDateError, setLastPickedDateError] = useState<boolean>(false); */
  // const [initialDate, setInitialDate] = useState()

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const loanEligibility = useSelector((state: any) => state.loan.loanEligibility)
  const status = useSelector((state: any) => state.loan.loanApplicationStatus)

  // useEffect(() => {
  //   if (loanEligibility !== null) {
  //     const date = dateObj(new Date(loanEligibility?.dateOfIncorporation))
  //     setInitialDate(date)
  //   }
  // }, [loanEligibility])

  const initialValues = {
    loanPurpose: loanEligibility ? loanEligibility?.loanPurpose : '',
    amountRequested: loanApplication ? loanApplication.amountRequested : '',
    durationInMonths: loanApplication ? loanApplication.durationInMonths : '',
    companyUEN: loanApplication ? loanApplication?.companyUEN : '',
    companyName: loanEligibility ? loanEligibility?.companyName : '',
    businessMobileNumber: loanEligibility?.businessMobileNumber
      ? loanEligibility?.businessMobileNumber
      : loanApplication?.mobileNumber,
    businessEmailAddress: loanEligibility ? loanEligibility?.businessEmailAddress : '',
    industryType: loanEligibility ? loanEligibility?.industryType : '',
    turnover: loanEligibility ? loanEligibility?.turnover : 0,
    profit: loanEligibility ? loanEligibility?.profit : 0,
    totalMonthlyInstallmentsToBanks: loanEligibility
      ? loanEligibility?.totalMonthlyInstallmentsToBanks
      : 0,
    totalMonthlyInstallmentsToNonBanks: loanEligibility
      ? loanEligibility?.totalMonthlyInstallmentsToNonBanks
      : 0,
    totalRevolvingCreditOutstandingToBanks: loanEligibility
      ? loanEligibility?.totalRevolvingCreditOutstandingToBanks
      : 0,
    totalRevolvingCreditOutstandingToNonBanks: loanEligibility
      ? loanEligibility?.totalRevolvingCreditOutstandingToNonBanks
      : 0,
    currentLitigationAmount: loanEligibility ? loanEligibility?.currentLitigationAmount : 0,
    anyOutstandingDebts: loanEligibility ? loanEligibility?.anyOutstandingDebts : false,
    otherType: loanEligibility ? loanEligibility?.otherType : '',
    dateOfIncorporation: loanEligibility
      ? new Date(loanEligibility?.dateOfIncorporation)
      : undefined,
  }

  const validationSchema = Yup.object().shape({
    // loanPurpose: Yup.string().required(errorMsg.required),
    loanPurpose: Yup.string()
      .required('Please select a Loan Purpose')
      .test('mustSelect', 'Please select a Loan Purpose', (value: any) => {
        return value !== '-'
      }),
    amountRequested: Yup.number()
      .required(errorMsg.required)
      .min(minAmount, 'Amount range should be between 100,000 - 3,000,000')
      .max(maxAmount, 'Amount range should be between 100,000 - 3,000,000'),
    durationInMonths: Yup.number()
      .required(errorMsg.required)
      .min(minDuration, 'Duration range should be between 3 - 36 months')
      .max(maxDuration, 'Duration range should be between 3 - 36 months')
      .test('isInteger', 'Must be an integer', (value: any) => {
        return Number.isInteger(value)
      }),
    companyUEN: Yup.string().required(errorMsg.required),
    companyName: Yup.string().required('Company Name is required'),
    businessMobileNumber: Yup.string()
      .required('Mobile number is required')
      .test('mobileValidation', 'Please enter valid Singapore number', (value: any) => {
        if (!value) return false
        // Use libphonenumber-js to validate phone number format
        const number = parsePhoneNumberWithError(value, 'SG')
        // Use libphonenumber-js to validate phone number format
        return isValidPhoneNumber(value, 'SG') && number.isValid() && number.country === 'SG'
      }),
    businessEmailAddress: Yup.string()
      .required('Business Email Address is required')
      .email('Enter Valid Email'),
    dateOfIncorporation: Yup.string()
      .required('Date of Incorporation is required')
      .typeError('Date of Incorporation is required'),
    industryType: Yup.string()
      .required('Industry is required')
      .test('mustSelectType', 'Please select an Industry Type', (value: any) => {
        return value !== '-'
      }),
    otherType: Yup.string().when('industryType', {
      is: (industryType: string) => industryType === 'other',
      then: Yup.string().required('Please enter your industry type'),
    }),
    turnover: Yup.number()
      .typeError('Annual turnover cannot be less than 0')
      .test('notlessThanZero', 'Annual turnover should be greater than 0', (value: any) => {
        return value > 0
      })
      .test('turnOverNotZero', 'Annual Turnover cannot be 0', (value: any) => {
        return value !== 0
      }),
    profit: Yup.number()
      .typeError('Net Operating income cannot be less than 0')
      .test('lessthanZero', 'Net Operating income should be greater than 0', (value: any) => {
        return value > 0
      })
      .test('notZero', 'Net Operating income should be greater than 0', (value: any) => {
        return value !== 0
      }),
    anyOutstandingDebts: Yup.boolean().required(errorMsg.required),
    totalMonthlyInstallmentsToBanks: Yup.number().when('anyOutstandingDebts', {
      is: true,
      then: Yup.number()
        .typeError('Total Monthly Installments To Banks cannot be less than 0')
        .test(
          'installment',
          'Total Monthly Installments To Banks cannot be less than 0',
          (value: any) => value >= 0
        ),
    }),

    totalMonthlyInstallmentsToNonBanks: Yup.number().when('anyOutstandingDebts', {
      is: true,
      then: Yup.number()
        .typeError('Total Monthly Installments To Non Banks cannot be less than 0')
        .test(
          'nonBanks',
          'Total Monthly Installments To Non Banks cannot be less than 0',
          (value: any) => value >= 0
        ),
    }),

    totalRevolvingCreditOutstandingToBanks: Yup.number().when('anyOutstandingDebts', {
      is: true,
      then: Yup.number()
        .typeError('Total Revolving Credit Outstanding To Banks cannot be less than 0')
        .test(
          'creditOutstanding',
          'Total Revolving Credit Outstanding To Banks cannot be less than 0',
          (value: any) => value >= 0
        ),
    }),

    totalRevolvingCreditOutstandingToNonBanks: Yup.number().when('anyOutstandingDebts', {
      is: true,
      then: Yup.number()
        .typeError('Total Revolving Credit Outstanding To Non Banks cannot be less than 0')
        .test(
          'revolving',
          'Total Revolving Credit Outstanding To Non Banks cannot be less than 0',
          (value: any) => value >= 0
        ),
    }),

    currentLitigationAmount: Yup.number().when('anyOutstandingDebts', {
      is: true,
      then: Yup.number()
        .typeError('Current Litigation Amount cannot be less than 0')
        .test(
          'currentLitigationAmount',
          'Current Litigation Amount cannot be less than 0',
          (value: any) => value >= 0
        ),
    }),
  })

  const handleLoanDurationRange = (value: string) => {
    formik.setFieldValue('durationInMonths', value)
  }

  const handleLoanAmountRange = (value: string) => {
    formik.setFieldValue('amountRequested', value)
    //if(error.match(/ name/i)) formik.setFieldError('name', error);
  }
  const formik = useFormik({
    // enableReinitialize: true,
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      /* if(lastPickedDateError){
        formik.setFieldError('dateOfIncorporation', 'Please select valid Date');
        return;
      } */
      const {
        amountRequested,
        durationInMonths,
        loanPurpose,
        companyName,
        businessMobileNumber,
        businessEmailAddress,
        industryType,
        otherType,
        turnover,
        profit,
        totalMonthlyInstallmentsToBanks,
        totalMonthlyInstallmentsToNonBanks,
        totalRevolvingCreditOutstandingToBanks,
        totalRevolvingCreditOutstandingToNonBanks,
        currentLitigationAmount,
        anyOutstandingDebts,
        dateOfIncorporation,
      } = trim(values)

      if (
        anyOutstandingDebts &&
        totalMonthlyInstallmentsToBanks <= 0 &&
        totalMonthlyInstallmentsToNonBanks <= 0 &&
        totalRevolvingCreditOutstandingToBanks <= 0 &&
        totalRevolvingCreditOutstandingToNonBanks <= 0 &&
        currentLitigationAmount <= 0
      ) {
        return
      }

      const principal = amountRequested
      const actualIntrestRate = Number(
        industryOptions.find((o: any) => o.value === industryType)?.pricing
      )
      // Monthly interest rate : Divide by 100 to convert to fraction
      const interestRate = actualIntrestRate / 1200
      const tenure = durationInMonths
      //EMI = P × r × (1 + r) n/ ((1 + r) n - 1) where P= Loan amount, r= interest rate, n=tenure in number of months
      const top = Math.pow(1 + interestRate, tenure)
      const bottom = top - 1
      const ratio = top / bottom
      const emi = (principal * interestRate * ratio).toFixed(2)

      dispatch(fetchStartWithForward())
      updateApplication({
        variables: {
          data: {
            amountRequested: parseFloat(amountRequested),
            durationInMonths: parseInt(durationInMonths),
            interestRate: Number(actualIntrestRate),
            mibCompanyName: companyName,
            emi: Number(emi),
          },
          where: {
            id: loanApplication.id,
          },
        },
      })

      if (loanEligibility === null || loanEligibility?.id === undefined) {
        createLoanEligibility({
          variables: {
            data: {
              loanPurpose,
              companyName,
              businessMobileNumber,
              businessEmailAddress,
              industryType,
              otherType,
              dateOfIncorporation,
              turnover: parseInt(turnover),
              profit: parseInt(profit),
              anyOutstandingDebts,
              totalMonthlyInstallmentsToBanks: anyOutstandingDebts
                ? parseInt(totalMonthlyInstallmentsToBanks)
                : 0,
              totalMonthlyInstallmentsToNonBanks: anyOutstandingDebts
                ? parseInt(totalMonthlyInstallmentsToNonBanks)
                : 0,
              totalRevolvingCreditOutstandingToBanks: anyOutstandingDebts
                ? parseInt(totalRevolvingCreditOutstandingToBanks)
                : 0,
              totalRevolvingCreditOutstandingToNonBanks: anyOutstandingDebts
                ? parseInt(totalRevolvingCreditOutstandingToNonBanks)
                : 0,
              currentLitigationAmount: anyOutstandingDebts ? parseInt(currentLitigationAmount) : 0,
              application: {
                connect: {
                  id: loanApplication.id,
                },
              },
            },
          },
        })
      } else {
        updateLoanElgibility({
          variables: {
            data: {
              loanPurpose,
              companyName,
              businessMobileNumber,
              businessEmailAddress,
              industryType,
              otherType,
              dateOfIncorporation,
              turnover: parseInt(turnover),
              profit: parseInt(profit),
              anyOutstandingDebts,
              totalMonthlyInstallmentsToBanks: anyOutstandingDebts
                ? parseInt(totalMonthlyInstallmentsToBanks)
                : 0,
              totalMonthlyInstallmentsToNonBanks: anyOutstandingDebts
                ? parseInt(totalMonthlyInstallmentsToNonBanks)
                : 0,
              totalRevolvingCreditOutstandingToBanks: anyOutstandingDebts
                ? parseInt(totalRevolvingCreditOutstandingToBanks)
                : 0,
              totalRevolvingCreditOutstandingToNonBanks: anyOutstandingDebts
                ? parseInt(totalRevolvingCreditOutstandingToNonBanks)
                : 0,
              currentLitigationAmount: anyOutstandingDebts ? parseInt(currentLitigationAmount) : 0,
            },
            where: {
              id: loanEligibility.id,
            },
          },
        })
      }
      setSubmitting(false)
    },
  })

  /* useEffect(() => {
    if(lastPickedDateError){
      formik.setFieldError('dateOfIncorporation', 'Please select valid Date');
    }

  }, [formik.errors]) */

  const backLink = () => {
    const applicationType = localStorage.getItem('loanType')
    if (applicationType === AlexiApplicationTypes.LOAN_APPLICATION) {
      if (status === 2) {
        dispatch(setLoanStep(1))
        dispatch(setLoanSubStep(0))
        history.push('/application')
      } else {
        history.push('/application/type')
      }
    }
  }
  return (
    <div className='d-flex flex-column flex-column-fluid'>
      {/* Add styles to head */}
      <style>{calendarIconStyles}</style>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='cardNew'>
          <div className='section-heading'>
            <h2>Loan Details</h2>
            <hr className='text-gray-400' />
          </div>
          <div className='row mb-10'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                I want to borrow
              </label>
              <NumberFormat
                name='amountRequested'
                value={formik.values.amountRequested}
                className='form-control form-control-solid'
                // displayType={'text'}
                thousandSeparator={true}
                prefix={'SG$'}
                allowNegative={true} // Explicitly allow negative values
                isNumericString={true} // Treat the input as a numeric string
                onValueChange={(values: any) => {
                  let { value } = values
                  // Ensure we accept any value including negative
                  formik.setFieldValue('amountRequested', value)
                }}
                onBlur={(event: any) => {
                  let { value } = event.target
                  // For negative values, we need special handling since the prefix is at the beginning
                  // Check if the value contains a negative sign
                  const isNegative = event.target.value.includes('-')

                  // Remove the prefix (SG$) and any commas
                  if (isNegative) {
                    // For negative values, the format might be -SG$200,000 or SG$-200,000
                    value = value.replace(/[SG$,]/g, '')
                  } else {
                    value = value.substring(3) // Remove prefix
                    value = value.replace(/[,$]/g, '') // Remove commas and any dollar signs
                  }

                  let parsedValue = value ? parseFloat(value) : 0

                  // Always keep the original entered value, including negative values
                  formik.setFieldValue('amountRequested', parsedValue)
                  // Show appropriate validation errors
                  if (Number(parsedValue) < 0) {
                    formik.setFieldError('amountRequested', 'Amount cannot be negative')
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) === 0) {
                    formik.setFieldError('amountRequested', 'Amount cannot be zero')
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) < minAmount) {
                    formik.setFieldError(
                      'amountRequested',
                      `Amount cannot be less than SG$${minAmount.toLocaleString()}`
                    )
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) > maxAmount) {
                    formik.setFieldError(
                      'amountRequested',
                      `Amount cannot exceed SG$${maxAmount.toLocaleString()}`
                    )
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else {
                    // Only round valid values
                    let roundedValue = Math.round(Number(parsedValue) / 500) * 500
                    formik.setFieldValue('amountRequested', roundedValue)
                  }

                  formik.setFieldTouched('amountRequested', true)
                }}
              />
              {formik.touched.amountRequested && formik.errors.amountRequested && (
                <div className='text-danger mt-2'>{formik.errors.amountRequested}</div>
              )}
              <RangeSlider
                // id="amountRequested"
                min={minAmount}
                max={maxAmount}
                step={5000}
                tooltip='on'
                tooltipPlacement='top'
                tooltipLabel={(currentValue) => `SG$${currentValue}`}
                value={formik.values.amountRequested}
                onChange={(event: any) => {
                  handleLoanAmountRange(event.target.value)
                }}
                className='rangeSlider'
                // onChange={({target:{value}}) => { if(regexNumber.test(value)) formik.setFieldValue('total', value) }}
                // onChange={formik.handleChange}
              />
              <div className='d-flex flex-row justify-content-between'>
                <div>SG$100,000</div>
                <div>SG$3,000,000</div>
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                How long for? (Months)
              </label>
              <input
                name='durationInMonths'
                type='number'
                min={minDuration}
                max={maxDuration}
                step={1}
                className='form-control form-control-solid'
                value={formik.values.durationInMonths}
                onChange={formik.handleChange}
                onBlur={(event: any) => {
                  let { value } = event.target
                  let parsedValue = value ? parseInt(value) : 0

                  // Always keep the original entered value, including negative values
                  formik.setFieldValue('durationInMonths', parsedValue)

                  // Show appropriate validation errors
                  if (parsedValue < 0) {
                    formik.setFieldError('durationInMonths', 'Duration cannot be negative')
                  } else if (parsedValue === 0) {
                    formik.setFieldError('durationInMonths', 'Duration cannot be zero')
                  } else if (parsedValue < minDuration) {
                    formik.setFieldError(
                      'durationInMonths',
                      `Duration cannot be less than ${minDuration} months`
                    )
                  } else if (parsedValue > maxDuration) {
                    formik.setFieldError(
                      'durationInMonths',
                      `Duration cannot exceed ${maxDuration} months`
                    )
                  } else if (!Number.isInteger(parsedValue)) {
                    formik.setFieldError('durationInMonths', 'Duration must be a whole number')
                  }

                  formik.setFieldTouched('durationInMonths', true)
                }}
              />
              {formik.touched.durationInMonths && formik.errors.durationInMonths && (
                <div className='text-danger mt-2'>{formik.errors.durationInMonths}</div>
              )}
              <RangeSlider
                // id="durationInMonths"
                min={3}
                max={36}
                tooltip='on'
                tooltipPlacement='top'
                tooltipLabel={(currentValue) => `${currentValue} months`}
                value={formik.values.durationInMonths}
                // onChange={formik.handleChange}
                onChange={(event: any) => {
                  handleLoanDurationRange(event.target.value)
                }}
                className='rangeSlider'
              />
              <div className='d-flex flex-row justify-content-between'>
                <div>3 months</div>
                <div>36 months</div>
              </div>
            </div>

            <div className='col-md-12 mt-3'>
              <label htmlFor='' className='input-field-label required'>
                Loan Purpose
              </label>
              <div className='col-sm-12'>
                <select
                  name='loanPurpose'
                  className='form-select form-control-lg  border border-1'
                  value={formik.values.loanPurpose}
                  onChange={formik.handleChange}
                >
                  <option value='-'>---- Select Purpose ----</option>
                  {loanPurpose.map(({ label, value }: any, index: number) => (
                    <option key={index} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
                {formik.touched.loanPurpose && formik.errors.loanPurpose && (
                  <div className='text-danger mt-2'>{formik.errors.loanPurpose}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='cardNew'>
          <div className='section-heading'>
            <h2>Company Details</h2>
            <hr className='text-gray-400' />
          </div>
          <div className='row mb-10'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                UEN
              </label>
              <div className='col-sm-12'>
                <input
                  name='companyUEN'
                  type='text'
                  className='form-control  form-control-solid'
                  value={formik.values.companyUEN}
                  onChange={formik.handleChange}
                  disabled
                />
                {formik.touched.companyUEN && formik.errors.companyUEN && (
                  <div className='text-danger mt-2'>{formik.errors.companyUEN}</div>
                )}
              </div>{' '}
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Company Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='companyName'
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  value={formik.values.companyName}
                  onChange={formik.handleChange}
                />
                {formik.touched.companyName && formik.errors.companyName && (
                  <div className='text-danger mt-2'>{formik.errors.companyName}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Business Mobile Number
              </label>
              <div className='col-sm-12'>
                {/* <input 
              name="businessMobileNumber"
              type="text" 
              className="form-control form-control-lg form-control-solid" 
              value={formik.values.businessMobileNumber}
              onChange={formik.handleChange}
            /> */}
                <PhoneInput
                  id='businessMobileNumber'
                  international
                  defaultCountry='SG'
                  country='SG'
                  countryCallingCodeEditable={false}
                  countrySelectComponent={StaticCountrySelect}
                  value={formik.values.businessMobileNumber}
                  onChange={(value) => formik.setFieldValue('businessMobileNumber', value)}
                  placeholder='Enter phone number'
                  className='int-phone-input'
                  // readOnly
                />
                {formik.touched.businessMobileNumber && formik.errors.businessMobileNumber && (
                  <div className='text-danger mt-2'>{formik.errors.businessMobileNumber}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Business Email Address
              </label>
              <div className='col-sm-12'>
                <input
                  name='businessEmailAddress'
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  value={formik.values.businessEmailAddress}
                  onChange={formik.handleChange}
                />
                {formik.touched.businessEmailAddress && formik.errors.businessEmailAddress && (
                  <div className='text-danger mt-2'>{formik.errors.businessEmailAddress}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Date of Incorporation
              </label>
              <div className='col-sm-12'>
                <DatePicker
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={100}
                  dropdownMode='select'
                  showMonthDropdown
                  placeholderText='MM/DD/YYYY'
                  onKeyDown={(e) => e.preventDefault()}
                  showIcon
                  // Custom styles to position the icon
                  customInput={
                    <input
                      className='form-control form-control-lg form-control-solid'
                      style={{ position: 'relative' }}
                    />
                  }
                  // Move icon to right side and center vertically
                  calendarIconClassname='calendar-icon-right'
                  icon={
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='1em'
                      height='1em'
                      viewBox='0 0 48 48'
                    >
                      <mask id='ipSApplication0'>
                        <g fill='none' stroke='#fff' strokeLinejoin='round' strokeWidth='4'>
                          <path strokeLinecap='round' d='M40.04 22v20h-32V22'></path>
                          <path
                            fill='#fff'
                            d='M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z'
                          ></path>
                        </g>
                      </mask>
                      <path
                        fill='currentColor'
                        d='M0 0h48v48H0z'
                        mask='url(#ipSApplication0)'
                      ></path>
                    </svg>
                  }
                  // Add inline styles for calendar icon
                  wrapperClassName='date-picker-wrapper'
                  required={true}
                  maxDate={today}
                  selected={formik.values.dateOfIncorporation}
                  onChangeRaw={(event: any) => {
                    // Handle manual text entry
                    const inputValue = event.target.value
                    const inputDate = new Date(inputValue)

                    // First check if the date is valid
                    if (isNaN(inputDate.getTime())) {
                      formik.setFieldError(
                        'dateOfIncorporation',
                        'Please enter valid Date of incorporation in MM/DD/YYYY format'
                      )
                      return
                    }

                    // Then check if date is in the future
                    if (inputDate > today) {
                      formik.setFieldError('dateOfIncorporation', 'Date cannot be in the future')
                      formik.setFieldValue('dateOfIncorporation', '')
                      // Prevent the onChange handler from firing with this value
                      event.preventDefault()
                      // Reset the value in the input field to the previous valid value
                      event.target.value = formik.values.dateOfIncorporation
                        ? formik.values.dateOfIncorporation.toLocaleDateString()
                        : ''
                    }
                  }}
                  onChange={(value: any) => {
                    // Check if selected date is in the future
                    if (value && value > today) {
                      formik.setFieldError('dateOfIncorporation', 'Date cannot be in the future')
                      formik.setFieldValue('dateOfIncorporation', '')
                      // Prevent the onChange handler from firing with this value
                      return
                    }
                    formik.setFieldValue('dateOfIncorporation', value)
                  }}
                />

                {formik.touched.dateOfIncorporation && formik.errors.dateOfIncorporation && (
                  <div className='text-danger mt-2'>{formik.errors.dateOfIncorporation} &nbsp;</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Industry
              </label>
              <div className='col-sm-12'>
                <select
                  name='industryType'
                  className='form-select form-control-lg  border border-1'
                  value={formik.values.industryType}
                  onChange={formik.handleChange}
                >
                  <option value='-'>---- Select Industry option ----</option>
                  {industryOptions.map(({ label, value }: any, index: number) => (
                    <option key={index} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
                {formik.touched.industryType && formik.errors.industryType && (
                  <div className='text-danger mt-2'>{formik.errors.industryType}</div>
                )}
              </div>
            </div>
            {formik.values.industryType === 'other' && (
              <div className='col-md-6 mb-5'>
                <label htmlFor='' className='input-field-label required'>
                  Other Industry Type
                </label>
                <div className='col-sm-12'>
                  <input
                    name='otherType'
                    type='text'
                    className='form-control form-control-lg form-control-solid'
                    value={formik.values.otherType}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.otherType && formik.errors.otherType && (
                    <div className='text-danger mt-2'>{formik.errors.otherType}</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='cardNew'>
          <div className='section-heading'>
            <h2>Declare your Financials</h2>
            <hr className='text-gray-400' />
          </div>
          <div className='row mb-2'>
            <div className='col-md-6 mb-5'>
              <div className='row'>
                <label htmlFor='' className='input-field-label required'>
                  Annual Turnover
                </label>
                <div className='col-sm-12'>
                  <NumberFormat
                    name='turnover'
                    value={formik.values.turnover}
                    className='form-control form-control-lg form-control-solid'
                    thousandSeparator={true}
                    prefix={'SG$ '}
                    onValueChange={(values: any) => {
                      const { value } = values
                      formik.setFieldValue('turnover', value)
                    }}
                  />
                  {formik.touched.turnover && formik.errors.turnover && (
                    <div className='text-danger mt-2'>{formik.errors.turnover}</div>
                  )}
                </div>
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Net Operating Income (profit)
              </label>
              <div className='col-sm-12'>
                <NumberFormat
                  name='profit'
                  value={formik.values.profit}
                  className='form-control form-control-lg form-control-solid'
                  thousandSeparator={true}
                  prefix={'SG$ '}
                  onValueChange={(values: any) => {
                    const { value } = values
                    formik.setFieldValue('profit', value)
                  }}
                />
                {formik.touched.profit && formik.errors.profit && (
                  <div className='text-danger mt-2'>{formik.errors.profit}</div>
                )}
              </div>
            </div>
          </div>

          {formik.values.anyOutstandingDebts && (
            <>
              <div className='row mb-1'>
                {formik.values.anyOutstandingDebts &&
                  formik.values.totalMonthlyInstallmentsToBanks <= 0 &&
                  formik.values.totalMonthlyInstallmentsToNonBanks <= 0 &&
                  formik.values.totalRevolvingCreditOutstandingToBanks <= 0 &&
                  formik.values.totalRevolvingCreditOutstandingToNonBanks <= 0 &&
                  formik.values.currentLitigationAmount <= 0 && (
                    <div className='text-danger'>
                      At least one field below should be greater than 0
                    </div>
                  )}
              </div>
              <div className='row mb-10'>
                <div className='col-md-6 mb-5'>
                  <label htmlFor='' className='input-field-label'>
                    Total Monthly Installments to banks
                  </label>
                  <div className='col-sm-12'>
                    <NumberFormat
                      name='totalMonthlyInstallmentsToBanks'
                      value={
                        formik.values.anyOutstandingDebts
                          ? formik.values.totalMonthlyInstallmentsToBanks
                          : '0.00'
                      }
                      className='form-control form-control-lg form-control-solid'
                      thousandSeparator={true}
                      prefix={'SG$ '}
                      onValueChange={(values: any) => {
                        const { value } = values
                        formik.setFieldValue('totalMonthlyInstallmentsToBanks', value)
                      }}
                    />
                  </div>
                  {formik.touched.totalMonthlyInstallmentsToBanks &&
                    formik.errors.totalMonthlyInstallmentsToBanks && (
                      <div className='text-danger mt-2'>
                        {formik.errors.totalMonthlyInstallmentsToBanks}
                      </div>
                    )}
                </div>
                <div className='col-md-6 mb-5'>
                  <label htmlFor='' className='input-field-label'>
                    Total Monthly Installments to non-banks
                  </label>
                  <div className='col-sm-12'>
                    <NumberFormat
                      name='totalMonthlyInstallmentsToNonBanks'
                      value={
                        formik.values.anyOutstandingDebts
                          ? formik.values.totalMonthlyInstallmentsToNonBanks
                          : '0.00'
                      }
                      className='form-control form-control-lg form-control-solid'
                      thousandSeparator={true}
                      prefix={'SG$ '}
                      onValueChange={(values: any) => {
                        const { value } = values
                        formik.setFieldValue('totalMonthlyInstallmentsToNonBanks', value)
                      }}
                    />
                    {formik.touched.totalMonthlyInstallmentsToNonBanks &&
                      formik.errors.totalMonthlyInstallmentsToNonBanks && (
                        <div className='text-danger mt-2'>
                          {formik.errors.totalMonthlyInstallmentsToNonBanks}
                        </div>
                      )}
                  </div>
                </div>
                <div className='col-md-6 mb-5'>
                  <label htmlFor='' className='input-field-label'>
                    Total Revolving Credit outstanding to banks
                  </label>
                  <div className='col-sm-12'>
                    <NumberFormat
                      name='totalRevolvingCreditOutstandingToBanks'
                      value={
                        formik.values.anyOutstandingDebts
                          ? formik.values.totalRevolvingCreditOutstandingToBanks
                          : '0.00'
                      }
                      className='form-control form-control-lg form-control-solid'
                      thousandSeparator={true}
                      prefix={'SG$ '}
                      onValueChange={(values: any) => {
                        const { value } = values
                        formik.setFieldValue('totalRevolvingCreditOutstandingToBanks', value)
                      }}
                    />
                    {formik.touched.totalRevolvingCreditOutstandingToBanks &&
                      formik.errors.totalRevolvingCreditOutstandingToBanks && (
                        <div className='text-danger mt-2'>
                          {formik.errors.totalRevolvingCreditOutstandingToBanks}
                        </div>
                      )}
                  </div>
                </div>

                <div className='col-md-6 mb-5'>
                  <label htmlFor='' className='input-field-label'>
                    Total Revolving Credit outstanding to non-banks
                  </label>
                  <div className='col-sm-12'>
                    <NumberFormat
                      name='totalRevolvingCreditOutstandingToNonBanks'
                      value={
                        formik.values.anyOutstandingDebts
                          ? formik.values.totalRevolvingCreditOutstandingToNonBanks
                          : '0.00'
                      }
                      className='form-control form-control-lg form-control-solid'
                      thousandSeparator={true}
                      prefix={'SG$ '}
                      onValueChange={(values: any) => {
                        const { value } = values
                        formik.setFieldValue('totalRevolvingCreditOutstandingToNonBanks', value)
                      }}
                    />
                    {formik.touched.totalRevolvingCreditOutstandingToNonBanks &&
                      formik.errors.totalRevolvingCreditOutstandingToNonBanks && (
                        <div className='text-danger mt-2'>
                          {formik.errors.totalRevolvingCreditOutstandingToNonBanks}
                        </div>
                      )}
                  </div>
                </div>
                <div className='col-md-6 mb-5'>
                  <label htmlFor='' className='input-field-label'>
                    Current Litigation Amount
                  </label>
                  <div className='col-sm-12'>
                    <NumberFormat
                      name='currentLitigationAmount'
                      value={
                        formik.values.anyOutstandingDebts
                          ? formik.values.currentLitigationAmount
                          : 0
                      }
                      className='form-control form-control-lg form-control-solid'
                      thousandSeparator={true}
                      prefix={'SG$ '}
                      onValueChange={(values: any) => {
                        const { value } = values
                        formik.setFieldValue('currentLitigationAmount', value)
                      }}
                    />
                    {formik.touched.currentLitigationAmount &&
                      formik.errors.currentLitigationAmount && (
                        <div className='text-danger mt-2'>
                          {formik.errors.currentLitigationAmount}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className='cardNew stickeyFooter'>
          <div className='d-flex justify-content-between'>
            <button className='button button-outline-primary' onClick={backLink}>
              <LeftArowIcon color='currentColor' fontSize={12} />
              Back
            </button>
            <button type='submit' className='button button-primary '>
              Save and Continue <RightAeroIcon color='currentColor' />
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export { Step1Sub3, industryOptions, loanPurpose }
